export default "__VITE_ASSET__581e7928__"